import React from 'react';

import {
  appEvents,
  DownloadLimitReachedSnackbar,
  DownloadLimitSnackbar
} from 'modules';
import { filter } from 'rxjs';



export interface IProps {
}

export const FC: React.FC<IProps> = props => {
  const [snackbarArgs, setSnackbarArgs] = React.useState<appEvents.ISnackbarEventArgs | null>(null);



  React.useEffect(() => {
    const sub = appEvents.observable()
      .pipe(filter(ev => ev?.type === 'snackbar'))
      .subscribe(event => {
        if (event?.type === 'snackbar') {
          setSnackbarArgs(event.args);
        }
      });

    return () => sub.unsubscribe();
  }, []);



  if (!snackbarArgs) {
    return (<div />);
  }

  if (snackbarArgs.type === 'downloadLimit') {
    return (
      <DownloadLimitSnackbar.FC
        subscriptionStatus={snackbarArgs.subscriptionStatus}
        currentDownloads={snackbarArgs.currentDownloads}
        totalDownloads={snackbarArgs.totalDownloads}
        onClose={() => setSnackbarArgs(null)} />
    );

  } else if (snackbarArgs.type === 'downloadLimitReached') {
    return (
      <DownloadLimitReachedSnackbar.FC
        onClose={() => setSnackbarArgs(null)} />
    );
  }

  return (<div />);
};
